"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogThumbnail = exports.DEFAULT_MAX_BODY_LENGTH = void 0;

var react_1 = __importDefault(require("react"));

var BlogThumbnail_styles_1 = require("./BlogThumbnail.styles");

exports.DEFAULT_MAX_BODY_LENGTH = 150;

var BlogThumbnail = function BlogThumbnail(props) {
  var _a;

  var maxBodyLength = (_a = props.body.maxLength) !== null && _a !== void 0 ? _a : exports.DEFAULT_MAX_BODY_LENGTH;
  var trimmedBody = props.body.text && props.body.text.length > maxBodyLength ? trim(props.body.text, maxBodyLength) : props.body.text;
  return react_1.default.createElement(BlogThumbnail_styles_1.Container, {
    className: "blog-thumbnail",
    "data-testid": "blog-thumbnail"
  }, react_1.default.createElement("a", {
    className: "blog-thumbnail-image-link",
    "data-testid": "blog-thumbnail-image-link",
    href: props.link.href
  }, react_1.default.createElement(BlogThumbnail_styles_1.ImageContainer, {
    className: "blog-thumbnail-image",
    "data-testid": "blog-thumbnail-image"
  }, props.image())), react_1.default.createElement("h2", {
    className: "blog-thumbnail-title",
    "data-testid": "blog-thumbnail-title"
  }, props.title), react_1.default.createElement("div", {
    className: "blog-thumbnail-body",
    "data-testid": "blog-thumbnail-body"
  }, trimmedBody), react_1.default.createElement(BlogThumbnail_styles_1.BlogThumbnailLink, {
    className: "blog-thumbnail-link",
    "data-testid": "blog-thumbnail-link",
    href: props.link.href
  }, props.link.label));
};

exports.BlogThumbnail = BlogThumbnail;

var trim = function trim(text, maxLength) {
  var trimmedWords = text.substring(0, maxLength).split(' ').slice(0, -1);
  return trimmedWords.join(' ').concat('...');
};